import type { ReactNode } from "react";

import CareSuperLogo from "@/components/CareSuperLogo";
import ULThemeCard from "@/components/ULThemeCard";

// Layout for every Beneficiary Claims screen (sign-up, log in, email code).
//
// Deliberately NOT JourneyLayout: there's no stepper. Members joining have a
// five-step wizard; a beneficiary has two short screens, and a progress rail
// would only add weight to something people often do in a hard week.
//
// Same flat white page and 480px centred column as the standalone ACUL
// screens (email-identifier-challenge on the reset path), so it reads as part
// of the same CareSuper set. Buttons pick up #294fed from applyCareSuperBrand().
interface BeneficiaryLayoutProps {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
}

function BeneficiaryLayout({
  title,
  subtitle,
  children,
}: BeneficiaryLayoutProps) {
  return (
    <div className="min-h-screen w-full bg-white flex flex-col items-center px-4 py-12">
      <div className="w-full max-w-[480px]">
        <ULThemeCard className="theme-universal w-full gap-0">
          <CareSuperLogo className="h-10 w-auto self-center mb-2" />
          <p
            className="text-center text-sm font-semibold tracking-wide text-body-text mb-6"
            data-testid="beneficiary-product"
          >
            Beneficiary Claims
          </p>
          <h1 className="text-center text-header text-(length:--ul-theme-font-title-size) font-title mb-2">
            {title}
          </h1>
          {subtitle ? (
            <p className="text-center text-body-text text-(length:--ul-theme-font-body-text-size) font-body mb-6">
              {subtitle}
            </p>
          ) : null}
          {children}
        </ULThemeCard>
      </div>
    </div>
  );
}

export default BeneficiaryLayout;
